var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main_slogan",style:({'--font-length': _vm.font_length,'--offset-top': _vm.offset_top}),attrs:{"id":"main_slogan"}},[_c('h1',[_vm._v(_vm._s(_vm.slogan))])])}
var staticRenderFns = []

export { render, staticRenderFns }